import useModal from 'hooks/useModal';
import useChartMutation from 'hooks/chart/useChartMutation';

type TProps = {
  category: string;
  id: number;
  data: FormData;
  isEdit: boolean;
  isAutoSave?: boolean;
  patientId?: string;
  courseInfoId?: string;
  chartRound?: string;
  onLoading: (isLoading: boolean) => void;
  onConfirm: () => void;
};

const useChartRegister = (afterAutoSave?: (data: any) => void) => {
  const { openModal } = useModal();
  const { chartMutation } = useChartMutation(afterAutoSave);

  const chartRegister = ({
    category,
    id,
    data,
    isEdit,
    isAutoSave,
    patientId,
    courseInfoId,
    chartRound,
    onLoading,
    onConfirm,
  }: TProps) => {
    if (isAutoSave) {
      chartMutation({
        category,
        id,
        data,
        isAutoSave,
      });
      return;
    }
    if (!isEdit) {
      if (category === 'practice') {
        chartMutation({
          category,
          id,
          data,
          onLoading,
        });
      } else {
        onConfirm();
      }
    } else {
      openModal({
        title: '작성 중인 차트를 저장하시겠습니까?',
        text: '차트를 저장하는 경우, 수정한 사항이 차트에 반영됩니다. 작성하신 차트를 저장하시겠습니까?',
        onSubmit: () => {
          onLoading(true);
          chartMutation({
            category,
            id,
            data,
            patientId,
            courseInfoId,
            chartRound,
            onLoading,
          });
        },
      });
    }
  };

  return { chartRegister };
};

export default useChartRegister;
